import DataApi from './DataApi';

class SchedulerApi extends DataApi {
  constructor() {
    super('scheduler');
  }

  list(tab = 'active') {
    const q = new URLSearchParams({ tab: String(tab || 'active') }).toString();
    return this.get(`?${q}`);
  }

  listExecutionHistory() {
    return this.get('/execution-history');
  }

  deleteExecutionHistory(ids) {
    return this.deleteWithBody('/execution-history', { ids });
  }

  deleteExecutionHistoryRow(historyId) {
    return this.delete(`/execution-history/${historyId}`);
  }

  getLogs(id) {
    return this.get(`/${id}/logs`);
  }

  runNow(id) {
    return this.post(`/${id}/run-now`, {});
  }

  pause(id) {
    return this.post(`/${id}/pause`, {});
  }

  clone(id) {
    return this.post(`/${id}/clone`, {});
  }

  update(id, body) {
    return this.put(`/${id}`, body);
  }

  create(body) {
    return this.post('/', body);
  }
}

export default SchedulerApi;
